// extracted by mini-css-extract-plugin
export var h2_semi_bold_serp = "j_Q";
export var noBoxShadow = "j_S";
export var serpCard = "j_N";
export var serpCardContainer = "j_M";
export var serpDescription = "j_R";
export var serpLink = "j_P";